<template>
  <div class="googleBtn" :class="{'hide':!ishttp}">
    <div id="g_id_signin" ref="googleBtn"></div>
  </div>
</template>
<script>
import { jwtDecode } from 'jwt-decode'
export default {
  name: '',
  data() {
    return {
      ishttp:false,
      clientId: process.env.VUE_GOOGLE_CLIENTID,
      //clientId: this.$interface.client.googleClientId
    }
  },
  created() {
  },
  mounted() {
    this.googleAccounts()
  },
  methods: {
    // google登录按钮初始化
    async googleAccounts() {
      
      let that = this
      // window.addEventListener("load", () => {
      //   //生成按钮

      // }); 

        window.google.accounts.id.initialize({
          // 主要就是填写client_id
          client_id: that.clientId,
          auto_select: false,
          callback: that.handleCredentialResponse,
        });
      window.google.accounts.id.renderButton(
        document.getElementById("g_id_signin"), {
          type: "icon", //图标:'icon',图标加文字:'standard'
          theme: "filled_blue", //主题'outline','filled_blue','filled_black'
          size: "large", //大小:'large','medium','small'
          //text:"continue_with",
        }
      )
    },
    //登录后回调 res:jwt格式的用户数据 (此字段是采用 base64 编码的 JSON 网络令牌 (JWT) 字符串形式的 ID 令牌。)
    async handleCredentialResponse(res) {
      //console.log(res, 'handleCredentialResponse')
      let that=this
      //jwt 解码
      try {
        //解码成功
        const decoded = jwtDecode(res.credential);
        //console.log(decoded)
        if(decoded){
          const data={GoogleUserId:decoded.sub}
          that.$get(that.$interface.GetMemberByGoogleUserId,data).then(res=>{
            var data=""
            if(res.Result!=0){
              data=res.Data
            }
            that.$emit('getData',data,decoded)
          })
        }
      } catch (error) {
        console.error('JWT解码失败', error);
      }
    }
  }
}

</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .hide{
    display: none;
  }
</style>



// WEBPACK FOOTER //
// src/components/google-identity.vue